/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabelaesthete3Inputs */



/**
* | output |
* | --- |
* | "The Vibe Curator" |
*
* @param {Personalityarchetypelabelaesthete3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabelaesthete3 = /** @type {((inputs?: Personalityarchetypelabelaesthete3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabelaesthete3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Vibe Curator")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Curador de Estilo")
	return /** @type {LocalizedString} */ ("Вайб-куратор")
});
export { personalityarchetypelabelaesthete3 as "personalityArchetypeLabelAesthete" }